import { contractSchedule, missionOnDay } from './planningDates';
import { planningContractType, planningTone } from './planningContractType';
export function planningScheduledOnDay(item, day) {
  return missionOnDay(item, day) && (!(item.isOpenPosition || item.isConfirmedPosition) || !item.workedDays?.length || item.DateDebut === item.DateFin ||
    item.workedDays.some(value => String(value).toLowerCase() === day.toLocaleDateString('fr-FR', { weekday: 'long' })));
}
export function filterPlanningPositions(items, filter) {
  return items.filter(item => filter === 'requests' ? item.isContractRequest : filter === 'open' ? item.isOpenPosition : filter === 'contracts' ? !item.isOpenPosition && !item.isContractRequest : true);
}
export function planningExportRows(items, days) {
  return items.flatMap(item => days.filter(day => planningScheduledOnDay(item, day)).map(day => {
    const schedule = contractSchedule(item);
    return {
      'Date': day.toLocaleDateString('fr-FR'),
      'Client': item.RaisonSociale || '',
      'Référence': item.NumeroContrat || '',
      'Poste': item.Qualification || item.TxtQualification || item.TxtConsigneQualification || '',
      'Type de contrat': planningContractType(item).label,
      'Statut': planningTone(item).label,
      'Intérimaire': item.isOpenPosition ? '' : item.NomPrenom || '',
      'À pourvoir': item.isOpenPosition ? item.remaining : '',
      'Début': schedule.start || '',
      'Fin': schedule.end || '',
    };
  })).sort((a, b) => {
    const parse = value => value.split('/').reverse().join('-');
    return parse(a.Date).localeCompare(parse(b.Date)) || a.Client.localeCompare(b.Client, 'fr');
  });
}
